import {Grid} from '@primer/react-brand/esm'
import {useRef} from 'react'

import {useIntersectionObserver} from '@github-ui/swp-core/lib/hooks/use-intersection-observer'

import {ColorDivider} from '../ColorDivider/ColorDivider'
import {CustomerStory, type CustomerStoryProps} from './CustomerStory/CustomerStory'

import Styles from './CustomerStories.module.css'

export interface CustomerStoriesProps {
  a11y: {
    title: string
  }
  items: CustomerStoryProps[]
}

export const defaultProps: Partial<CustomerStoriesProps> = {}

export const CustomerStories = (props: CustomerStoriesProps) => {
  const initializedProps: CustomerStoriesProps = {...defaultProps, ...props}
  const {a11y, items} = initializedProps

  const wrapperRef = useRef<HTMLDivElement>(null)
  const {isIntersecting} = useIntersectionObserver(wrapperRef, {threshold: 0.3, isOnce: true})

  return (
    <div ref={wrapperRef} className={Styles['CustomerStories']}>
      <h2 className="visually-hidden">{a11y.title}</h2>
      <div className={Styles['CustomerStories__gridContent']}>
        <Grid columnGap="none" rowGap="none" enableGutters={false}>
          <Grid.Column span={12} className={Styles['CustomerStories__dividerColumn']}>
            <div className={Styles['CustomerStories__divider']}>
              <ColorDivider variant="3" isThick hasDucky shouldAnimateIn canAnimateIn={isIntersecting} />
            </div>
          </Grid.Column>

          <Grid.Column span={12}>
            <Grid columnGap="none" rowGap="none" enableGutters={false}>
              {items.map(item => (
                <Grid.Column
                  key={item.cta.url}
                  span={{xsmall: 12, large: 4}}
                  className={Styles['CustomerStories__column']}
                >
                  <CustomerStory {...item} />
                </Grid.Column>
              ))}
            </Grid>
          </Grid.Column>
        </Grid>
      </div>
    </div>
  )
}
